/**
 * Canonical Wikificial category system.
 * Single source of truth used by:
 *  - LeftSidebar (nav)
 *  - Directory pill row (filter)
 *  - CommandPalette (search)
 *
 * Order reflects editorial priority (mainstream/creative first,
 * followed by professional & vertical categories).
 * Live counts come from GET /api/categories at render time.
 */
import {
  MessageSquare, Bot, Palette, Film, Music, Mic, PenLine,
  Wand2, Zap, Code, Microscope, Briefcase, GraduationCap,
  Megaphone, Scale, Coins, Heart,
} from "lucide-react";

export const CATEGORIES = [
  { key: "Chat & LLMs",            label: "Chat & LLMs",            icon: MessageSquare, tint: "text-[#0B1220]" },
  { key: "AI Agents",              label: "AI Agents",              icon: Bot,           tint: "text-[#0B1220]" },
  { key: "Image",                  label: "Image",                  icon: Palette,       tint: "text-[#0B1220]" },
  { key: "Video",                  label: "Video",                  icon: Film,          tint: "text-[#0B1220]" },
  { key: "Music & Audio",          label: "Music & Audio",          icon: Music,         tint: "text-[#0B1220]" },
  { key: "Voice",                  label: "Voice",                  icon: Mic,           tint: "text-[#0B1220]" },
  { key: "Writing & Copy",         label: "Writing & Copy",         icon: PenLine,       tint: "text-[#0B1220]" },
  { key: "No-Code & Vibe Coding",  label: "No-Code & Vibe Coding",  icon: Wand2,         tint: "text-[#0B1220]" },
  { key: "Automation & Workflows", label: "Automation & Workflows", icon: Zap,           tint: "text-[#0B1220]" },
  { key: "Coding & Dev",           label: "Coding & Dev",           icon: Code,          tint: "text-[#0B1220]" },
  { key: "Research",               label: "Research",               icon: Microscope,    tint: "text-[#0B1220]" },
  { key: "Productivity",           label: "Productivity",           icon: Briefcase,     tint: "text-[#0B1220]" },
  { key: "Business & Marketing",   label: "Business & Marketing",   icon: Megaphone,     tint: "text-[#0B1220]" },
  { key: "Education",              label: "Education",              icon: GraduationCap, tint: "text-[#0B1220]" },
  { key: "Health & Wellness",      label: "Health & Wellness",      icon: Heart,         tint: "text-[#0B1220]" },
  { key: "Legal",                  label: "Legal",                  icon: Scale,         tint: "text-[#0B1220]" },
  { key: "Web3 & Crypto",          label: "Web3 & Crypto",          icon: Coins,         tint: "text-[#0B1220]" },
];

export const categoryToHref = (key) =>
  key ? `/?cat=${encodeURIComponent(key)}` : "/";

export const categoryTestId = (label) =>
  `cat-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")}`;
